/** Склеює класи, пропускаючи порожні. Без залежності заради одного рядка. */
export function cx(...parts) {
    return parts.filter(Boolean).join(" ");
}
//# sourceMappingURL=cx.js.map